import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const res = await axios.post('/api/auth/forgot-password', { email: email.trim() });
      setSuccess(res.data.message || 'İşlem tamamlandı.');
    } catch (err) {
      setError(err.response?.data?.error || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-dark px-4">
      <div className="bg-gradient-card p-8 rounded-xl shadow-card border-2 border-gold/30 w-full max-w-md">
        <h1 className="text-3xl font-bold text-center text-gold mb-2">Şifremi Unuttum</h1>
        <p className="text-gray-400 text-center text-sm mb-8">
          Kayıtlı e-posta adresinize şifre sıfırlama bağlantısı gönderilir.
        </p>

        {success ? (
          <div className="space-y-6">
            <div className="bg-emerald-500/10 border border-emerald-500/50 text-emerald-200 px-4 py-3 rounded-lg text-sm">
              {success}
            </div>
            <Link
              to="/login"
              className="block w-full text-center bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-gold"
            >
              Giriş sayfasına dön
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-500/10 border border-red-500 text-red-500 px-4 py-3 rounded-lg">
                {error}
              </div>
            )}

            <div>
              <label className="block text-white mb-2 font-medium">
                E-posta <span className="text-gold">*</span>
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@email.com"
                className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
                required
                autoComplete="email"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Gönderiliyor...' : 'Sıfırlama bağlantısı gönder'}
            </button>
          </form>
        )}

        <div className="mt-6 text-center space-y-2">
          <Link to="/login" className="text-gold hover:text-gold-light transition-colors text-sm block">
            ← Girişe dön
          </Link>
          <Link to="/" className="text-gray-400 hover:text-gold text-sm block">
            Ana sayfa
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
